import { FC } from 'react';

import { TypeStatisticsSectionFields } from '@/core/generated-types';

const StatisticsSection: FC<TypeStatisticsSectionFields> = ({
  backgroundColor,
  title,
  number,
  label,
}) => {
  return (
    <section
      className={`py-8 md:py-[70px] bg-${backgroundColor?.fields.color}`}
      data-testid="statistics-section"
    >
      <div className="w-full lg:flex mx-auto max-w-[1128px] px-6 lg:px-0 items-center">
        <div className="lg:w-[475px] lg:ml-auto">
          <span className="font-bold text-2xl md:text-[40px] md:leading-[48px]">
            {title}
          </span>
        </div>
        <div className="flex items-start lg:items-center mt-4 md:mt-0">
          <div className="lg:ml-[101px] lg:mr-[58px] flex items-center">
            <span className="font-bold text-[48px] md:text-[64px] leading-[56px] lg:leading-[72px]">
              {number}
            </span>
            <span className="font-bold text-[48px] md:text-[64px] leading-[56px] lg:leading-[72px] lg:ml-1">
              %
            </span>
          </div>
          <div className="w-full text-base lg:w-[360px] lg:text-[18px] lg:leading-[26px] ml-3 lg:ml-0 ">
            <span>{label}</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatisticsSection;
